import { combineReducers, compose, createStore, applyMiddleware, Action, Store } from '@reduxjs/toolkit';
import thunk, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

import State from './State';

import snackbar from './snackbar/slice';
import dialog from './dialog/slice';
import loading from './loading/slice';
import shell from './shell/slice';
import drawer from './drawer/slice';

const reducer = combineReducers({
  form: formReducer,
  snackbar: snackbar.reducer,
  dialog: dialog.reducer,
  loading: loading.reducer,
  shell: shell.reducer,
  drawer: drawer.reducer,
});

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  State,
  unknown,
  Action<string>
>

export type AppDispatch = ThunkDispatch<State, unknown, Action<string>>;

/** NOTE: debugging purposes */ 
// declare global {
//   interface Window {
//     __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
//   }
// }
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const generateStore = (): Store => createStore(
//   reducer,
//   composeEnhancers(applyMiddleware(thunk))
// );

const generateStore = (): Store => createStore(
  reducer,
  compose(applyMiddleware(thunk))
);

export default generateStore;